import { createSlice } from '@reduxjs/toolkit';
import { getReportThunk } from './Report.thunk';
import { Report, ReportFetchParams } from './Report.type';

export const reportSlice = createSlice({
  name: 'report',
  initialState: {
    data: [],
    params: {},
    loading: true,
  },
  reducers: {
    resetReportAction: (state, action) => ({
      data: [],
      params: {},
      loading: false
    }),
  },
  extraReducers: builder => {
    builder.addCase(getReportThunk.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getReportThunk.fulfilled, (state, action) => {
      const data = action.payload;
      state.data = data.data;
      state.params = data.params;
      state.loading = false;
    });
    builder.addCase(getReportThunk.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const getReport = (state: any) => {
  const report = state.report.data as Report;
  return report.map(item => ({
    ...item,
    id: item.id === null ? -1 : item.id,
    name: item.name === null || item.name === undefined ? 'Не задано' : item.name,
    data: item.data ? item.data.map(subItem => ({
      ...subItem,
      id: subItem.id === null ? -1 : subItem.id,
      name: subItem.name === null || subItem.name === undefined ? 'Не задано' : subItem.name,
    })) : [],
  }));
};
export const getReportParams = (state: any) => state.report.params as ReportFetchParams;

export default reportSlice.reducer;
